import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: '8rk8cdbm',
  dataset: 'production',
});
